import { IFormSettings } from '@tf/formbuilder'

export const FormWrapper = (controls: any, formMeta: any) => {
	return ({
		controls: controls,
		formMeta: formMeta,
	} as unknown) as IFormSettings
}
